import React from 'react'
import { Input } from "antd"
import { useTranslation } from 'react-i18next';
import useDebounce from '../../hooks/useDebonce';
import useUrlQueryParams from '../../hooks/useUrlQeryParams';
import { CiSearch } from "react-icons/ci";

const SearchInput = ({ setSearchVal, duration = 1000, width, className, placeholder }: { setSearchVal: React.Dispatch<string>, duration?: number, width?: number | "full", className?: string, placeholder?: string }) => {
    const { urlValue, writeToUrl } = useUrlQueryParams({});
    const debounse = useDebounce(urlValue.q, duration);
    const {t} = useTranslation()

    React.useEffect(() => {
        setSearchVal(debounse)
    }, [debounse])

    return <Input value={urlValue.q} className={`w-[${width === "full" ? "100%" : width+"px"}] h-[44px] ${className} rounded-xl bg-[#F0F0F0] pl-4 tex-[#29487E]`} placeholder={ placeholder ? `${t(placeholder)}` : `${t("Search by name")}...`} prefix={<CiSearch fontSize={24} color='#29487E' className='mr-2'/>} onChange={(e) => writeToUrl({ name: "q", value: e.target.value })}  allowClear/>

}

export default SearchInput;